<markant-dialog
  *ngIf="open"
  class="contact-request-dialog-wrapper"
  [open]="true"
  (close)="closeDialog()"
>
  <h2 class="dialog-header">
    {{ requestStateMap[currentRequestState()].headline | transloco }}
  </h2>
  <div *ngIf="currentRequestState() !== requestStates.SUCCESS">
    {{ requestStateMap[currentRequestState()].subtitle | transloco }}
  </div>
  <div
    class="dialog-content"
    *ngIf="currentRequestState() === requestStates.SUCCESS"
  >
    <img
      class="contact-image"
      src="assets/images/booking/requestSent.svg"
      width="410"
      height="281"
      alt="contactRequestSuccess"
    />

    <div class="dialog-content-inner">
      {{ requestStateMap[currentRequestState()].subtitle | transloco }}
    </div>
  </div>
  <div slot="footer">
    <ng-container
      *ngIf="
        currentRequestState() === requestStates.DEFAULT;
        else errorOnSubmition
      "
    >
      <markant-button
        [loading]="isRequestLoading"
        colorScheme="primary"
        variant="clear"
        data-markant-dialog-action="cancel"
      >
        <span>{{ 'common.cancel' | transloco }}</span>
      </markant-button>

      <markant-button [loading]="isRequestLoading" (click)="approve()">
        {{
          'booking.priceRequests.orgDetail.contactRequest.sendRequest'
            | transloco
        }}
      </markant-button>
    </ng-container>

    <ng-template #errorOnSubmition>
      <markant-button (click)="closeDialog()">
        {{ 'common.close' | transloco }}
      </markant-button>
    </ng-template>
  </div>
</markant-dialog>
